"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7268],{

/***/ 1831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ Card7; },
/* harmony export */   "CQ": function() { return /* binding */ Card11; },
/* harmony export */   "GL": function() { return /* binding */ Card3; },
/* harmony export */   "P": function() { return /* binding */ Card9; },
/* harmony export */   "Pe": function() { return /* binding */ Card13; },
/* harmony export */   "_7": function() { return /* binding */ Card12; },
/* harmony export */   "st": function() { return /* binding */ Card1; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86812);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36623);
/* harmony import */ var _utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28631);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26706);






var Card1 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var ref;
    // const { deviceWidth } = IS_SERVER ? { deviceWidth: 0 } : getDeviceInfo();
    // const style = {
    //   height: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '400px'
    //       : widgetConfig?.image_dimension?.height
    //     : widgetConfig?.image_dimension?.height,
    //   minWidth: widgetConfig.card_cta_visibility
    //     ? deviceWidth < 900
    //       ? '300px'
    //       : '750px'
    //     : '300px',
    // };
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-1",
        // style={style}
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: theme === null || theme === void 0 ? void 0 : (ref = theme.cta_config) === null || ref === void 0 ? void 0 : ref.banner_cta
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("widget_cta")
            }))
        ]
    }, key);
};
var Card3 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-3",
        // style={{ height: widgetConfig.image_dimension.height }}
        style: {
            height: "auto"
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                    theme: theme,
                    item: category
                })
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card7 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, cardIndx = param.cardIndx, onClick = param.onClick, skewDirection = param.skewDirection;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var skewAngle = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_2__/* .deviceWidth */ .o > 990 ? 15 : 5;
    var skew = {
        right: "skew(".concat(skewAngle, "deg)"),
        left: "skew(-".concat(skewAngle, "deg)")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-7",
        style: {
            // height: widgetConfig.image_dimension.height,
            transform: skew[skewDirection]
        },
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundSize: "cover"
                }
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn ",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, cardIndx);
};
var Card9 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "category-card-9",
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc",
                children: category.name ? category.name : "Available Items"
            }),
            (widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.card_cta_visibility) && (!horizontal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "category-btn db-ns dn",
                children: "Explore"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "horizontal-category-btn db-ns dn",
                children: "Explore"
            }))
        ]
    }, key);
};
var Card11 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-11 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card12 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "category-card-12 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                        theme: theme,
                        item: category
                    }), ")"),
                    paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%"),
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                },
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "category-name tc mv0",
                children: category.name ? category.name : "Available Items"
            })
        ]
    }, key);
};
var Card13 = function(param) {
    var widgetConfig = param.widgetConfig, category = param.category, key = param.key, onClick = param.onClick, horizontal = param.horizontal;
    var theme = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_5__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-card-13 ".concat(horizontal ? "horizontal-card" : ""),
        onClick: function() {
            return onClick(category);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-100",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        backgroundImage: "url(".concat((0,_utils_returnSpecificImageUrl__WEBPACK_IMPORTED_MODULE_4__/* .returnSpecificImageUrl */ .B)({
                            theme: theme,
                            item: category
                        }), ")"),
                        paddingTop: "".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "%")
                    },
                    className: "image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "category-name tc mv0 z-5",
                    style: {
                        paddingTop: "calc(".concat(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.aspect_ratio, "% - 29px)")
                    },
                    children: category.name ? category.name : "Available Items"
                })
            ]
        })
    }, key);
};


/***/ }),

/***/ 17268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1831);
/* harmony import */ var _utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86423);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44541);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86812);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26706);








var CategoryWidget = function(props) {
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), widgetConfig = ref2[0], setWidgetConfig = ref2[1];
    var ref3 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_6__/* .useSSRSelector */ .kF)(function(state) {
        return {
            catalogCategories: state.catalogReducer.categories,
            storeData: state.storeReducer.store
        };
    }), catalogCategories = ref3.catalogCategories, storeData = ref3.storeData;
    var viewMoreBtnClick = function() {
        var ref;
        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.CATEGORIES), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var getNumOfCatItemsVisible = function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o <= 767) {
            return 8;
        } else {
            return 14;
        }
    };
    /**
   * showSeeMoreBtn comes in as prop and is used to conditionally render
   * the max amount of category items. In /categories page, there is no max limit on
   * the items that can be rendered at a time.
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((props === null || props === void 0 ? void 0 : props.config) && Object.keys(props.config)) {
            setWidgetConfig(props.config);
        }
    }, [
        props.config
    ]);
    /**
   * conditionally render show more/less btn
   * @return {*} boolean
   */ var renderShowBtn = function() {
        if (router.pathname === "/categories") return false;
        else {
            if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o <= 767) {
                return (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > 8;
            } else {
                return (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > 14;
            }
        }
    };
    var onCategoryItemClick = function(category) {
        var ref;
        if ((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain), undefined, {
                shallow: true
            });
        } else {
            var ref2;
            router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
    };
    var _renderCategoryCard = function(category, idx, cardNumber) {
        switch(cardNumber){
            case 1:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card11 */ .CQ, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            case 2:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card12 */ ._7, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            case 3:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card13 */ .Pe, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cards__WEBPACK_IMPORTED_MODULE_3__/* .Card11 */ .CQ, {
                    category: category,
                    widgetConfig: widgetConfig,
                    onClick: onCategoryItemClick
                }, idx);
        }
    };
    /**
   * max columns allowed to render is 7 (or 4 if mobile),
   * otherwise it renders the length of categories
   * @return {string} css attribute
   */ var getTemplateColumns = function() {
        var categoryLength = catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length;
        var columnNumber = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o <= 766 ? 4 : 7;
        return "repeat(".concat(categoryLength > columnNumber ? columnNumber : catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length, ", minmax(50px, 1fr))");
    };
    /**
   * return categories based on path
   * if pathname === "/categories", return all categories
   * otherwise return limited list of categories
   * @return {*} categories list
   */ var catalogList = function() {
        if (router.pathname === "/categories") {
            return catalogCategories;
        } else {
            return catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.slice(0, getNumOfCatItemsVisible());
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "vertical-categoryWidget2 flex justify-center items-center",
        children: widgetConfig && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "vertical-categoryWidget2__container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "vertical-categoryWidget2__title tc fw6",
                    children: widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "vertical-categoryWidget2__box",
                    style: {
                        gridTemplateColumns: getTemplateColumns()
                    },
                    children: ((ref = catalogList()) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = catalogList()) === null || ref1 === void 0 ? void 0 : ref1.map(function(category, index) {
                        return _renderCategoryCard(category, index, props.cardType);
                    }))
                }),
                renderShowBtn() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "flex justify-center items-center expandable-btn--container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: viewMoreBtnClick,
                        className: "expandable-btn",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "w-100 tc fw6",
                            children: "View More"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryWidget);


/***/ }),

/***/ 40619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 28631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ returnSpecificImageUrl; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/* harmony import */ var _compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40619);


/*
 returns either image_url or thumbnail_url,
 depending on the configuration of theme config 'product_image_quality_flag'
 */ function returnSpecificImageUrl(param) {
    var theme = param.theme, item = param.item;
    if (!theme || !(theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag)) return (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
    return (theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_CONFIG_CONSTANT.THUMBNAIL_IMAGE */ .of.THUMBNAIL_IMAGE ? (item === null || item === void 0 ? void 0 : item.thumbnail_url) || (item === null || item === void 0 ? void 0 : item.image_url) : (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
}


/***/ })

}]);